import { onMount, onDestroy, onView } from '@/modules/_'
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
import gsap from 'gsap'
import 'swiper/css'
import 'swiper/css/navigation'

export default function (element, dataset) {
  console.log('Bar graph module initializing...')

  const slider = element.querySelector('.swiper')
  const sliderWrapper = slider.querySelector('.swiper-wrapper.sotw-bars')
  const slides = sliderWrapper.querySelectorAll('.swiper-slide')
  const slideNext = element.querySelector("[data-slider='next']")
  const slidePrev = element.querySelector("[data-slider='previous']")

  // Gestion du reduced motion
  const reducedMotionQuery = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  )
  let prefersReducedMotion = reducedMotionQuery.matches
  reducedMotionQuery.addEventListener('change', (e) => {
    prefersReducedMotion = e.matches
  })

  const speed = prefersReducedMotion ? 0 : 750

  // Fonction centralisée pour animer les barres
  const animateBars = (slide) => {
    const bars = gsap.utils.toArray('.c-bar-row_track', slide)
    const bg = slide.querySelector('.c-bar-row')
    const labels = gsap.utils.toArray('.c-bar-row_label', slide)
    const values = gsap.utils.toArray('.c-bar-row_value', slide)

    if (bars.length === 0) return

    const tl = gsap.timeline()

    // Animation du background avec delay: 1
    if (bg) {
      tl.from(bg, {
        backgroundColor: '#FFF',
        duration: 0.5,
        ease: 'none',
        delay: 1, // ← delay: 1 pour init ET slideChange
      })
    }

    // Animation des barres
    tl.fromTo(
      bars,
      {
        scaleX: 0,
        transformOrigin: '0% 50%',
      },
      {
        scaleX: 1,
        duration: 1,
        ease: 'power2.out',
        stagger: 0.05,
        onStart: () => {
          bars.forEach((bar) => {
            const value = bar.querySelector('.c-bar-row_value')
            const h4 = value.querySelector('h4')
            const targetValue = parseFloat(h4.textContent)
            const counter = { value: 0 }

            gsap.to(counter, {
              value: targetValue,
              duration: 2,
              ease: 'power2.out',
              onUpdate: function () {
                h4.textContent = Math.round(counter.value) + '%'
              },
            })
          })
        },
      },
      '0'
    )

    if (labels.length > 0) {
      tl.from(
        labels,
        {
          opacity: 0,
          duration: 0.6,
          ease: 'power2.out',
          stagger: 0.05,
        },
        '<0.5'
      )
    }

    // Animation des values (fade in)
    if (values.length > 0) {
      tl.from(
        values,
        {
          opacity: 0,
          duration: 0.6,
          ease: 'power2.out',
          stagger: 0.05,
        },
        '<'
      )
    }
  }

  const swiper = new Swiper(slider, {
    modules: [Navigation, Pagination],
    slidesPerView: 'auto',
    centeredSlides: false,
    autoHeight: false,
    speed: speed,
    mousewheel: {
      enabled: false,
      forceToAxis: true,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    navigation: {
      nextEl: slideNext,
      prevEl: slidePrev,
    },
    slideActiveClass: 'is-active',
    on: {
      init: function () {
        const activeSlide = this.slides[this.activeIndex]
        onView(element, {
          autoStart: true,
          callback: ({ isIn }) => {
            // console.log("inView", isIn);

            if (isIn) {
              animateBars(activeSlide)
            }
          },
        })
      },
      slideChange: function () {
        const activeSlide = this.slides[this.activeIndex]
        animateBars(activeSlide)
      },
    },
  })

  // Clean up
  onDestroy(() => {
    reducedMotionQuery.removeEventListener('change', () => {})
    swiper.destroy(true, true)
  })
}
